import { useContext, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";

const ChangePasswordPage = () => {
  const { states, actions } = useContext(AuthContext);
  const { user, loading, error } = states;
  const { handleChangePassword, setError } = actions;

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [success, setSuccess] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    const result = await handleChangePassword(
      currentPassword,
      newPassword,
      confirmPassword
    );
    if (result) setSuccess("Password berhasil diubah 🎉");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h1 className="text-2xl font-semibold text-center mb-6">
          Ganti Password <br /> (api tidak bisa diakses)
        </h1>
        {error && (
          <div className="mb-4 text-red-600 bg-red-100 px-4 py-2 rounded">
            {error}
          </div>
        )}
        {success && (
          <div className="mb-4 text-green-600 bg-green-100 px-4 py-2 rounded">
            {success}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <input
            type="password"
            placeholder="Password Saat Ini"
            value={currentPassword}
            onChange={(e) => {
              setCurrentPassword(e.target.value);
              setError("");
            }}
            required
            className="w-full rounded-lg border px-4 py-2.5"
          />
          <input
            type="password"
            placeholder="Password Baru"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
              setError("");
            }}
            required
            className="w-full rounded-lg border px-4 py-2.5"
          />
          <input
            type="password"
            placeholder="Konfirmasi Password Baru"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setError("");
            }}
            required
            className="w-full rounded-lg border px-4 py-2.5"
          />
          <button
            type="submit"
            disabled={loading}
            className={`w-full rounded-lg py-2.5 text-white ${
              loading ? "bg-gray-400" : "bg-indigo-600 hover:bg-indigo-950"
            }`}>
            {loading ? "Memproses..." : "Save Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
